<script>
import { Line } from 'vue-chartjs';
import moment from 'moment';

export default {
  name: "CampaignLineStatistics",
  extends: Line,

  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Enviado',
            borderColor: '#68BD7B',
            backgroundColor: '#68BD7B',
            pointBackgroundColor: '#68BD7B',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'En Cola',
            borderColor: '#3b91f1',
            backgroundColor: '#3b91f1',
            pointBackgroundColor: '#3b91f1',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'Programado',
            borderColor: '#FFCE56',
            backgroundColor: '#FFCE56',
            pointBackgroundColor: '#FFCE56',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'Rechazado',
            borderColor: '#f87979',
            backgroundColor: '#f87979',
            pointBackgroundColor: '#f87979',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'Inválido',
            borderColor: '#7a7979',
            backgroundColor: '#7a7979',
            pointBackgroundColor: '#7a7979',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'Dado De Baja',
            borderColor: '#ff0000',
            backgroundColor: '#ff0000',
            pointBackgroundColor: '#ff0000',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'Opens',
            borderColor: '#00a9ff',
            backgroundColor: '#00a9ff',
            pointBackgroundColor: '#00a9ff',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          },
          {
            label: 'Clicks',
            borderColor: '#ee02ff',
            backgroundColor: '#ee02ff',
            pointBackgroundColor: '#ee02ff',
            pointRadius: [],
            pointHoverRadius: [],
            spanGaps: false,
            data: [],
            fill: false
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.4,
            cubicInterpolationMode: 'monotone'
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'YYYY-MM-DD'
              }
            },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Count'
            }
          }]
        }
      }
    };
  },

  mounted() {
    this.$eventHub.$on('statisticsDataUpdated', this.updateChartWithData);
  },

  methods: {
    updateChartWithData(responseData, statistics) {
      const sentData = [];
      const queuedData = [];
      const scheduledData = [];
      const rejectedData = [];
      const invalidData = [];
      const unsubscribedData = [];
      const opensData = [];
      const clicksData = [];
      const dates = [...new Set(responseData.map(entry => entry.sentDate))].sort();

      let formattedDates = [];
      if (statistics && statistics.startDate && statistics.endDate) {
        const startMoment   = moment(statistics.startDate);
        const endMoment     = moment(statistics.endDate);
        const currentMoment = startMoment.clone();
        while (currentMoment.isSameOrBefore(endMoment)) {
          formattedDates.push(currentMoment.format('YYYY-MM-DD'));
          currentMoment.add(1, 'day');
        }
      } else {
        formattedDates = dates.map(date => {
          const momentDate = moment(date);
          return momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : date;
        });
      }

      this.chartData.labels = formattedDates;

      formattedDates.forEach(dateLabel => {
        const dataByDate = responseData.filter(entry => entry.sentDate === dateLabel);
        const sentCount = dataByDate.find(entry => entry.status === 'SENT');
        const queuedCount = dataByDate.find(entry => entry.status === 'QUEUED');
        const scheduledCount = dataByDate.find(entry => entry.status === 'SCHEDULED');
        const rejectedCount = dataByDate.find(entry => entry.status === 'REJECTED');
        const invalidCount = dataByDate.find(entry => entry.status === 'INVALID');
        const unsubscribedCount = dataByDate.find(entry => entry.status === 'UNSUBSCRIBED');
        const opensCount = dataByDate.find(entry => entry.status === 'OPENS');
        const clicksCount = dataByDate.find(entry => entry.status === 'CLICKS');

        sentData.push(sentCount ? parseInt(sentCount.count) : 0);
        queuedData.push(queuedCount ? parseInt(queuedCount.count) : 0);
        scheduledData.push(scheduledCount ? parseInt(scheduledCount.count) : 0);
        rejectedData.push(rejectedCount ? parseInt(rejectedCount.count) : 0);
        invalidData.push(invalidCount ? parseInt(invalidCount.count) : 0);
        unsubscribedData.push(unsubscribedCount ? parseInt(unsubscribedCount.count) : 0);
        opensData.push(opensCount ? parseInt(opensCount.count) : 0);
        clicksData.push(clicksCount ? parseInt(clicksCount.count) : 0);
      });

      const allDataSets = [
        sentData,
        queuedData,
        scheduledData,
        rejectedData,
        invalidData,
        unsubscribedData,
        opensData,
        clicksData,
      ];

      allDataSets.forEach((dataset, index) => {
        const pointRadii = dataset.map(val => val > 0 ? 4 : 0);
        const pointHoverRadii = dataset.map(val => val > 0 ? 6 : 0);

        this.chartData.datasets[index].data = dataset;
        this.chartData.datasets[index].pointRadius = pointRadii;
        this.chartData.datasets[index].pointHoverRadius = pointHoverRadii;
      });

      this.renderChart(this.chartData, this.chartOptions);
    },

  }
}
</script>
